// import {
//   Component,
//   Input,
//   Output,
//   EventEmitter,
//   OnChanges,
//   SimpleChanges
// } from '@angular/core';

// @Component({
//   selector: 'app-searchable-select',
//   templateUrl: './searchable-select.component.html'
// })
// export class SearchableSelectComponent {

//   @Input() selectedValue: any;
//   @Output() selectedValueChange = new EventEmitter<any>(); // 🔥 MUST match name

//   @Input() items: any[] = [];
//   @Input() valueKey!: string;
//   @Input() labelKeys: string[] = [];
//   @Input() placeholder = 'Select';

//   searchText = '';
//   filteredItems: any[] = [];
//   selectedLabel = '';

//   ngOnChanges() {
//     this.filteredItems = [...this.items];
//     this.updateSelectedLabel();
//   }

//   onSelectionChange(value: any) {
//     this.selectedValue = value;
//     this.selectedValueChange.emit(value); // 🔥 REQUIRED
//     this.updateSelectedLabel();
//   }

//   clearSelection(event: Event) {
//     event.stopPropagation();
//     this.selectedValue = '';
//     this.searchText = '';
//     this.filteredItems = [...this.items];
//     this.selectedLabel = '';
//     this.selectedValueChange.emit(''); // 🔥 REQUIRED
//   }

//   getLabel(item: any): string {
//     return this.labelKeys.map(k => item[k]).filter(Boolean).join(' ');
//   }

//   private updateSelectedLabel() {
//     const selected = this.items.find(
//       item => item[this.valueKey] === this.selectedValue
//     );
//     this.selectedLabel = selected ? this.getLabel(selected) : '';
//   }
//    filterItems() {
//     const text = this.searchText.toLowerCase();
//     this.filteredItems = this.items.filter(item =>
//       this.getLabel(item).toLowerCase().includes(text)
//     );
//   } 
// }
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'app-searchable-select',
  templateUrl: './searchable-select.component.html',
  styleUrls: ['./searchable-select.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchableSelectComponent implements OnChanges {

  @Input() selectedValue: any;
  @Output() selectedValueChange = new EventEmitter<any>();

  @Input() items: any[] = [];
  @Input() valueKey!: string;
  @Input() labelKeys: string[] = [];
  @Input() placeholder = 'Select';

  searchText = '';
  filteredItems: any[] = [];
  selectedLabel = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items']) {
      this.filteredItems = [...this.items];
      this.updateSelectedLabel();
    }
    if (changes['selectedValue']) {
      this.updateSelectedLabel();
    }
  }

  onSelectionChange(value: any) {
    this.selectedValue = value;
    this.selectedValueChange.emit(value);
    this.updateSelectedLabel();
    this.searchText = ''; // Clear search on selection
    this.filterItems(); // Reset filter
  }

  clearSelection(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.selectedValue = '';
    this.searchText = '';
    this.filteredItems = [...this.items];
    this.selectedLabel = '';
    this.selectedValueChange.emit('');
  }

  getLabel(item: any): string {
    return this.labelKeys
      .map(k => item[k])
      .filter(Boolean)
      .join(' ');
  }

  private updateSelectedLabel() {
    const selected = this.items.find(
      item => item[this.valueKey] === this.selectedValue
    );
    this.selectedLabel = selected ? this.getLabel(selected) : '';
  }

  filterItems() {
    const text = this.searchText.toLowerCase().trim();
    if (!text) {
      this.filteredItems = [...this.items];
    } else {
      this.filteredItems = this.items.filter(item =>
        this.getLabel(item).toLowerCase().includes(text)
      );
    }
  }
}